/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, m: NonNullable<unknown>, k: NonNullable<unknown> }} Billing_Plan_TeamInputs */

const en_billing_plan_team = /** @type {(inputs: Billing_Plan_TeamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent team: ${i?.n} at once · Pemeriksa ${i?.m}/mo · your own computer ${i?.k} at once`)
};

const id_billing_plan_team = /** @type {(inputs: Billing_Plan_TeamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tim agent: ${i?.n} bersamaan · Pemeriksa ${i?.m}/bln · komputer sendiri ${i?.k} bersamaan`)
};

/**
* | output |
* | --- |
* | "Agent team: {n} at once · Pemeriksa {m}/mo · your own computer {k} at once" |
*
* @param {Billing_Plan_TeamInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_plan_team = /** @type {((inputs: Billing_Plan_TeamInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_TeamInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_plan_team(inputs)
	return en_billing_plan_team(inputs)
});